
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'

import { mapActions } from 'vuex'

export default {
name: 'app',
components: {
Tabbar, TabbarItem
},
data () {
return {
title: document.title
}
},
mounted () {
if (this.$route.meta.title) {
this.title = this.$route.meta.title
}

this.scrollHandler = () => {
let isBottom = false
let scrollBox = document.body || document.documentElement
let clientHeight = window.screen.availHeight
let scrollHeight = scrollBox.scrollHeight
let scrollTop = window.pageYOffset ? window.pageYOffset : scrollBox.scrollTop

if (scrollHeight > clientHeight) {
if (scrollTop + clientHeight >= scrollHeight - 5) {
isBottom = true
}
}

this.updateScrollPosition({path: this.$route.path, top: scrollTop, isBottom: isBottom})
}

setTimeout(() => {
let scrollBox = window
scrollBox.removeEventListener('scroll', this.scrollHandler, false)
scrollBox.addEventListener('scroll', this.scrollHandler, false)
}, 100)
},
beforeDestroy () {
window.removeEventListener('scroll', this.scrollHandler, false)
},
computed: {
showHeader () {
return !this.$route.meta.hideHeader
},
showTabbar () {
return !this.$route.meta.hideTabbar
},
paddingTop () {
return this.$route.meta.hideHeader ? '0' : '46px'
},
paddingBottom () {
return this.$route.meta.hideTabbar ? '0' : '55px'
},
leftOptions () {
return {
preventGoBack: true,
backText: '',
showBack: this.$route.meta.showBack
}
},
rightOptions () {
return {
showMore: this.$route.meta.showMore
}
}
},
methods: {
...mapActions([
'updateScrollPosition'
]),
callBack () {
if (this.$route.query.index === 'true' ||
window.history.length <= 1) {
this.$router.push({name: 'Study'})
} else {
this.$router.back()
}
},
callShare () {
if (this.$refs.page && this.$refs.page.share) {
this.$refs.page.share()
}
},
changeTitle (title) {
if (title) {
this.title = title
}
},
componentMounted (componentName) {
}
},
watch: {
$route (to, from) {
if (to.meta.title) {
this.title = to.meta.title
}
},
isLoading (loading) {
if (loading) {
this.$vux.loading.show()
} else {
this.$vux.loading.hide()
}
}
}
}



// WEBPACK FOOTER //
// ./src/App.vue